<template>
    <div v-if="value.extra && value.extra.type === 'deviceEmissions'" class="event-extra">
        <div v-for="device in getDeviceEmissions(value)" :key="device.id" class="event-extra-device-emission flex-h">
            <v-tooltip bottom>
                <template v-slot:activator="{on, attrs}">
                    <div
                        v-bind="attrs" v-on="on"
                        class="device-item-marker"
                        :style="{backgroundImage: device.isEmitting ? 'url(/icons/round-red.png)' : 'url(/icons/round-green.png)'}"
                    />
                </template>
                <span>
                    {{ device.isEmitting ? 'Излучал' : 'Не излучал' }}
                </span>
            </v-tooltip>
            <router-link :to="`/devices/view/${device.id}`">{{ device.name }}</router-link>
        </div>
    </div>
</template>


<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import {Prop} from 'vue-property-decorator'
import {Event, EventExtraDeviceEmission, getEventExtraDeviceEmissions} from '@/models/Event'

@Component
export default class EventExtraDeviceEmissions extends Vue
{
    @Prop({required: true, type: Object})
    value!: Event

    getDeviceEmissions(event: Event): EventExtraDeviceEmission[] {
        return getEventExtraDeviceEmissions(event)
    }
}
</script>
